import { render, staticRenderFns } from "./picPay.vue?vue&type=template&id=02bca31c&scoped=true&"
import script from "./picPay.vue?vue&type=script&lang=js&"
export * from "./picPay.vue?vue&type=script&lang=js&"
import style0 from "./picPay.vue?vue&type=style&index=0&id=02bca31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bca31c",
  null
  
)

export default component.exports